import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const SparkLineShared = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (ctx) {
        // Destroy previous chart instance if exists
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }
        let gradientRed = ctx.createLinearGradient(20, 0, 20, 70);
        gradientRed.addColorStop(0, "rgba(251, 214, 208,0.41)");
        gradientRed.addColorStop(0.5, "white");
        gradientRed.addColorStop(1, "white");

        chartInstance.current = new Chart(ctx, {
          type: "line",
          data: {
            labels: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
            ],
            datasets: [
              {
                data: [1.5, 6.8, 5.8, 8.4, 7.2, 4.3, 5.4, 6.5, 9.2, 4.5, 1.0],
                borderColor: "#FFC4BB",
                borderWidth: 2,
                tension: 0.4,
                fill: true,
                backgroundColor: gradientRed,
                order: 3,
                pointRadius: 0,
                onHoverPointRadius: 0,
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              easing: "easeInOutQuad",
              duration: 520,
            },
            scales: {
              x: {
                display: false,
                grid: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
              y: {
                display: false,
                grid: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
            },
          },
        });
      }
    }

    // Cleanup function
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  return <canvas ref={chartRef} />;
};

export default SparkLineShared;
